import 'Sass/views/fraser-app.scss';
import '../apps/fraser/fraser.js';